import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

const truncateText = (text, charLimit) => {
  if (text.length > charLimit) {
    return text.slice(0, charLimit) + "..";
  }
  return text;
};

export const CartComponent = ({
  item,
  increaseQuantity,
  decreaseQuantity,
  deleteItem,
  isLoading,
}) => {
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  return (
    <div className="container-fluid p-4 ">
      <div
        style={{ borderRadius: "20px" }}
        className="row align-items-center mb-3 p-4 bg-white shadow mt-3"
        key={item.item_id}
        data-product-id={item.item_id}
      >
        <div
          className="col-12 col-md-3 text-center mb-3 mb-md-0"
          style={{ paddingLeft: "0px", paddingRight: "0px" }}
        >
          <img
            src={item.reward ? item.reward : item.image}
            alt={item.name || "Product Image"}
            style={{
              maxwidth: "100% !important",
              objectFit: "cover",
              borderRadius: "20px",
            }}
            className="img-fluid"
          />
        </div>

        <div className="col-12 col-md-5 text-lg-start text-md-center mb-2 mb-md-0 ">
          <h4
            className="mb-0 mb-2 text-md-center text-lg-left text-sm-center fw-bold"
            style={{ color: "#3789FF" }}
          >
            {item.name || "No name available"}
          </h4>
          <p
            style={{ fontSize: "16px" }}
            className="mb-2 d-none text-lg-left d-md-block"
          >
            {" "}
            {truncateText(item.description, 122) || "No description available"}
          </p>
        </div>

        <p style={{ fontSize: "14px" }} className="mb-3 d-md-none d-lg-none">
          {" "}
          {truncateText(item.description, 122) || "No description available"}
        </p>

        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-end align-items-center">
          <button
            type="button"
            className="btn btn-outline-primary border-2 m-1 me-1"
            onClick={decreaseQuantity}
            disabled={isLoading || item.quantity <= 1}
          >
            <i className="bi bi-dash "></i>
          </button>

          <input
            type="text"
            id="txtAcrescimo"
            value={item.quantity}
            readOnly
            className="form-control d-inline-block text-center mx-2"
            style={{
              maxWidth: "40px",
              height: "40px",
              borderRadius: "10px",
              fontSize: "18px",
            }}
          />

          <button
            type="button"
            className="btn btn-outline-secondary border-2  m-1  me-2"
            onClick={increaseQuantity}
            disabled={isLoading}
          >
            <i className="bi bi-plus"></i>
          </button>

          <button
            type="button"
            className="btn btn-danger m-1 ms-2"
            onClick={() => {
              setShowDeleteModal(true);
            }}
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>

        <Modal open={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: { xs: 2, sm: 4 },
              borderRadius: 2,
              width: { xs: "70%", sm: 400 },
              maxWidth: "100%",
            }}
          >
            <Typography variant="h6" fontSize={{ xs: 16, sm: 20 }}>
              Confirm Deletion
            </Typography>
            <Typography
              variant="body1"
              sx={{ mt: 2, fontSize: { xs: 14, sm: 16 } }}
            >
              Are you sure you want to delete this item?
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mt: 4,
                gap: { xs: 2, sm: 0 }, 
              }}
            >
              <Button
                variant="outlined"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </Button>
              <Button variant="contained" color="error" onClick={deleteItem}>
                Delete
              </Button>
            </Box>
          </Box>
        </Modal>

      </div>
    </div>
  );
};
